module.exports = __webpack_public_path__ + "img/rw.1ecda622.svg";